import { faCircleQuestion, faCircleStop, faTrash, faUser, faUserEdit } from "@fortawesome/free-solid-svg-icons"
import parse from 'html-react-parser'
import { useEffect, useReducer, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { Link } from "react-router-dom"
import useFetch from "../../../../../hook/useFetch"
import useFilter from "../../../../../hook/useFilter"
import useVariable from "../../../../../hook/useVariable"
import { backdropActions } from "../../../../../store/backdrop-slice"
import { notificationActions } from "../../../../../store/notification-slice"
import { userActions } from "../../../../../store/user-slice"
import InfoIcon from "../../../../InfoIcon"
import Modal from "../../../../Modal"
import Pagination from "./Pagination"

const Filter = (props) => {

    let defaultUserCount = useSelector((state) => state.user.filterUserCount)
    let pagination = useSelector((state) => state.user.pagination)

    let sliceFilters = useSelector(state => state.user.filter)
    let sliceActions = userActions
    let sliceItems = useSelector(state => state.user.users)
    const [isMount, setIsMount] = useState(false)

    const { children } = props


    let dispatch = useDispatch()

    const { doFilter } = useFilter()
    const { variableValue } = useVariable()

    const [paginationItems, setPaginationItems] = useState([])

    useEffect(() => {
        let items = []
        if (pagination) {
            pagination.map((item, key) => {

                items.push(<Pagination key={key} users={item} index={key} />)
            })
        }

        setPaginationItems(items)
    }, [pagination])


    let filter = useSelector((state) => state.user.filter)


    useEffect(() => {

        if (!isMount) {
            setIsMount(true)
            return
        }

        doFilter(sliceFilters, sliceItems, sliceActions)


    }, [filter])


    const appReducer = (state, action) => {
        switch (action.type) {
            case 'TOGGLE_MODAL':
                return { ...state, mountModal: !state.mountModal }
            case 'MODAL_DATA':
                return { ...state, modalData: action.data }
            case 'showactions':
                return { ...state, showactions: action.data }



        }
    }


    return <div className="p-3" >
        <div style={{ display: 'flex', justifyContent: 'space-between' }} >
            <div>
                <label>Pagination</label> <select name="filter-pagination" defaultValue={filter.pagination} className="mb-2" onChange={(event) => {
                    let value = variableValue(event.target.value)

                    dispatch(userActions.setFilter({
                        key: 'pagination',
                        value
                    }))



                }} >
                    <option value='' >All</option>

                    {
                        defaultUserCount.map((item, key) => {

                            return <option key={key} value={item} >{item}</option>
                        })
                    }
                </select>

                <input type="text" name="filter-email-username" className="mb-2" defaultValue={filter.search} placeholder="email or username" onInput={(event) => {
                    let value = variableValue(event.target.value)


                    dispatch(userActions.setFilter({
                        key: 'search',
                        value
                    }))



                }} />
            </div>


            <div>

                <Link className="btn btn-outline-secondary bgnt mb-2" to='/admin/user' ><InfoIcon icon={faUser} />New User</Link>
            </div>
        </div>
        {children}
        <div className="pagination-container">{paginationItems}</div>
        
    </div>
}


export default Filter